import {useCallback} from 'react';
import {produce} from 'immer';
import set from 'lodash/set';
import type {DataValue} from 'schemaDefinition/types';
import {useAppDispatch, useAppStore} from 'store/hooks';
import type {MetadataEditAction_ExpressionEdited} from '../metadataEditActionTypes';
import {
  metadataEditExpressionEdited,
  metadataEditNewExpressionEdited,
} from '../metadataEditSlice';
import type {ExpressionV4} from '../types';

export const useSetExpressionEditValue = (
  entityId: string,
  editActionType: MetadataEditAction_ExpressionEdited['type'],
) => {
  const dispatch = useAppDispatch();
  const {getState} = useAppStore();

  return useCallback(
    (localPath: string, value: DataValue) => {
      const expression = ((
        getState().metadataEdit.metadata?.expressions ?? []
      ).find(e => e.id === entityId) ?? {}) as ExpressionV4;
      const newExpression = produce(expression, draft => {
        set(draft, localPath, value);
      });

      if (editActionType === 'METADATAEDIT_NEW_EXPRESSION_EDITED') {
        dispatch(metadataEditNewExpressionEdited(newExpression));
      } else if (editActionType === 'METADATAEDIT_EXPRESSION_EDITED') {
        dispatch(metadataEditExpressionEdited(newExpression));
      }
    },
    [dispatch, editActionType, entityId, getState],
  );
};
